import { render } from "./BaseDataTableRemote.vue?vue&type=template&id=7dcb9e39"
import script from "./BaseDataTableRemote.vue?vue&type=script&lang=js"
export * from "./BaseDataTableRemote.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__